/** @version 0.2.0 */
/**
 * Agent frequencies. Ported verbatim from Simpliloquy V2's
 * `web/src/lib/palette.ts`. These (hue, chroma) values are Mark's
 * calibration against the prism arc; they are the canonical color
 * vocabulary for the Simpliloquy product family.
 *
 * 19 hand-picked points along the arc from alert red through warm pink.
 * Source of truth for the V2-V1cloud-V3 brand bridge.
 */

export interface PaletteEntry {
  id: string;
  name: string;
  hue: number;
  chroma: number;
  blurb?: string;
}

export const PALETTE: PaletteEntry[] = [
  { id: 'alert',     name: 'Alert',     hue: 15,  chroma: 1.0,  blurb: 'Vigilance' },
  { id: 'coral',     name: 'Coral',     hue: 25,  chroma: 0.9,  blurb: 'Warm outreach' },
  { id: 'orange',    name: 'Orange',    hue: 42,  chroma: 1.0,  blurb: 'Pipelines, deployment' },
  { id: 'amber',     name: 'Amber',     hue: 55,  chroma: 1.0,  blurb: 'Counsel, consigliere' },
  { id: 'gold',      name: 'Gold',      hue: 75,  chroma: 0.22, blurb: 'Conductor; pale, holds all frequencies' },
  { id: 'wheat',     name: 'Wheat',     hue: 85,  chroma: 0.45, blurb: 'The gathering' },
  { id: 'olive',     name: 'Olive',     hue: 100, chroma: 0.75, blurb: 'Structured data' },
  { id: 'forest',    name: 'Forest',    hue: 135, chroma: 0.9,  blurb: 'Recording the record' },
  { id: 'pine',      name: 'Pine',      hue: 150, chroma: 1.0,  blurb: 'The trail' },
  { id: 'teal',      name: 'Teal',      hue: 175, chroma: 1.0,  blurb: 'Architecture, orientation' },
  { id: 'cyan',      name: 'Cyan',      hue: 195, chroma: 1.0,  blurb: 'Data signal' },
  { id: 'sky',       name: 'Sky',       hue: 205, chroma: 1.0,  blurb: 'Visible' },
  { id: 'slate',     name: 'Slate',     hue: 225, chroma: 0.55, blurb: 'Ops ledger' },
  { id: 'indigo',    name: 'Indigo',    hue: 255, chroma: 1.0,  blurb: 'Scriptural authority' },
  { id: 'royal',     name: 'Royal',     hue: 265, chroma: 1.0,  blurb: 'Build surface' },
  { id: 'violet',    name: 'Violet',    hue: 290, chroma: 0.9,  blurb: 'Persistence' },
  { id: 'lavender',  name: 'Lavender',  hue: 300, chroma: 0.7,  blurb: 'Shelves' },
  { id: 'magenta',   name: 'Magenta',   hue: 320, chroma: 1.0,  blurb: 'Creative expression' },
  { id: 'rose',      name: 'Rose',      hue: 345, chroma: 0.95, blurb: 'The writer’s voice' },
];

export function findPalette(id: string | undefined): PaletteEntry | null {
  if (!id) return null;
  return PALETTE.find(p => p.id === id) ?? null;
}
